module.exports = __webpack_public_path__ + "src/assets/img/engine_six_color.42ac83b6.svg";